import type { FC } from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';

interface DotProps {
  className?: string;
}
const SingleDot: FC<DotProps> = ({ className }) => {
  return (
    <span
      className={cn(
        'loading-single bg-text300 h-1 w-1 rounded-full',
        className
      )}
    />
  );
};
const DoubleDot: FC<DotProps> = ({ className }) => {
  return (
    <span
      className={cn(
        'loading-double bg-text300 h-1 w-1 rounded-full',
        className
      )}
    />
  );
};

interface LoadingIconProps {
  dotClassName?: string;
}
export const LoadingIcon: FC<LoadingIconProps> = ({ dotClassName }) => {
  return (
    <div className="flex gap-1">
      <SingleDot className={dotClassName} />
      <DoubleDot className={dotClassName} />
      <SingleDot className={dotClassName} />
      <DoubleDot className={dotClassName} />
    </div>
  );
};
